import React from 'react'
import { Link } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { getColorByStationName } from '../../../../helpers/common'
import { CarIcon } from '../../../icons/CarIcon'
import { WalkMan } from '../../../icons/WalkMan'
import styles from './similarProjectCard.module.scss'
import { SimilarProjectCardProps } from './SimilarProjectCard.types'

export const SimilarProjectCard = (props: SimilarProjectCardProps) => {
  return (
    <Link
      to={`/project/${props.data.url_code}`}
      onClick={() => {
        ym('reachGoal', 'client link', {
          'project page': {
            'other projects click': {
              [`from ${props.currentProject}`]: `to ${props.data.UF_BUILDING_NAME}`,
            },
          },
        })
      }}
      key={props.data.UF_BUILDING_NAME}
    >
      <div className={styles.projectCard}>
        <h4>{props.data.UF_BUILDING_NAME}</h4>
        {props.data.LOCATION.UF_METRO_NAME?.length ? (
          <div className={styles.projectAddress}>
            <div
              style={{
                background: getColorByStationName(
                  props.data.LOCATION.UF_METRO_NAME
                ),
              }}
            />
            <p>{props.data.LOCATION.UF_METRO_NAME}</p>
            {Number(props.data.LOCATION.UF_METRO_TIME_ON_FOOT) > 0 && (
              <>
                <WalkMan className={styles.walkManLogo} />
                <p>{props.data.LOCATION.UF_METRO_TIME_ON_FOOT} мин</p>
              </>
            )}

            {Number(props.data.LOCATION.UF_METRO_TIME_ON_TRANSPORT) > 0 &&
              Number(props.data.LOCATION.UF_METRO_TIME_ON_FOOT) <= 0 && (
                <>
                  <CarIcon
                    width='15px'
                    height='15px'
                    style={{ margin: '0 8px 0 20px' }}
                  />
                  <p>{props.data.LOCATION.UF_METRO_TIME_ON_TRANSPORT} мин</p>
                </>
              )}
          </div>
        ) : (
          <div style={{ height: '20px' }} />
        )}
        <div className={styles.projectImgBlock}>
          <img
            className={styles.projectImg}
            src={props.data.UF_IMAGE}
            alt={props.data.UF_BUILDING_NAME}
          />
        </div>
        <span>
          От {props.data.PRICE_PER_SQUARE.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
          ₽ за м²
        </span>
      </div>
    </Link>
  )
}
